import React from 'react';
import { useWindowSize } from 'react-use';
import ConfettiComponent from 'react-confetti';
import useTimer from '../../utils/useTimer';

interface ConfettiProps {
  confettiPieces?: number;
  opacity?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  time?: number;
}

const Confetti: React.FC<ConfettiProps> = (props) => {
  const { confettiPieces, opacity = 8, time = 1 } = props;
  const { width, height } = useWindowSize();
  const { isActive } = useTimer({ initialActive: true, stopAt: time });

  return (
    <ConfettiComponent
      width={width}
      height={height}
      numberOfPieces={confettiPieces}
      recycle={isActive}
      opacity={opacity / 10}
    />
  );
};

export default Confetti;
